import React from "react";

import LinearProgress from "@material/react-linear-progress";

const BusyIndicator: React.FC = () => {
  return <LinearProgress indeterminate />;
};

export default BusyIndicator;
